import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ColumnHeader from 'components/NewHome/Table/ColumnHeader';
import Button from 'components/DesignSystem/Button';
import useMeteorologyStatus from 'hooks/NewHome/Table/MeteorologyStatus/useMeteorologyStatus';
import Tag from 'components/DesignSystem/Tag';

export default function MeteorologyStatus() {
  const {
    model,
    forecastDate,
    runtime,
    member,
    variable,
    status,
    setModel,
    setForecastDate,
    setRuntime,
    setMember,
    setVariable,
    setStatus,
    clearFilters,
    modelOptions,
    forecastDateOptions,
    runtimeOptions,
    memberOptions,
    variableOptions,
    statusOptions,
    filteredItems,
  } = useMeteorologyStatus();

  return (
    <div>
      <Row className="d-flex justify-content-end">
        <Col md="2" className="d-flex justify-content-end me-3">
          <Button
            type="tertiary"
            icon="no_filter"
            onClick={clearFilters}
          >
            Limpar Filtros
          </Button>
        </Col>
      </Row>
      <div className="ms-2 me-2">
        <Row className="mb-1 mt-2 ht-row">
          <ColumnHeader md={3} title="Modelo" value={model} setValue={setModel}>
            {modelOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={2} title="Data de previsão" value={forecastDate} setValue={setForecastDate}>
            {forecastDateOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={1} title="Runtime" value={runtime} setValue={setRuntime}>
            {runtimeOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={1} title="Membro" value={member} setValue={setMember}>
            {memberOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={1} title="Variável" value={variable} setValue={setVariable}>
            {variableOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={2} title="Status" value={status} setValue={setStatus}>
            {statusOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={2} title="Última Atualização" filterless />
        </Row>
        <div className="ht-row-container">
          {filteredItems.map((item) => (
            <Row key={`flux-status-${item.id}`} className="pt-3 pb-3 ht-row ht-entry-row">
              <Col md={3} className="home-table-entry-name">{item.modelName}</Col>
              <Col md={2} className="home-table-entry-attr">{item.forecastDate}</Col>
              <Col md={1} className="home-table-entry-attr">{item.runtime}</Col>
              <Col md={1} className="home-table-entry-attr">{item.member}</Col>
              <Col md={1} className="home-table-entry-attr">{item.variable}</Col>
              <Col md={2} className="home-table-entry-attr">
                <Tag
                  backgroundColor={item.statusColor}
                  className="meteorology-status-tag"
                >
                  {item.status}
                </Tag>
              </Col>
              <Col md={2} className="home-table-entry-attr">{item.lastUpdate}</Col>
            </Row>
          ))}
        </div>
      </div>
    </div>
  );
}
